import { render, staticRenderFns } from "./beginPage3.vue?vue&type=template&id=6a80f72a&scoped=true"
import script from "./beginPage3.vue?vue&type=script&lang=js"
export * from "./beginPage3.vue?vue&type=script&lang=js"
import style0 from "./beginPage3.vue?vue&type=style&index=0&id=6a80f72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80f72a",
  null
  
)

export default component.exports